<template>
  <div class="contactHolder fullWidth fRow jStart aCenter transition-fast" v-ripple>
    <div class="av fRow jCenter aCenter"
      v-bind:style="{backgroundColor: randomColor}">
      <span class="fRow jCenter aCenter">
        {{name.charAt(0)}}‌{{name.charAt(name.length - 1)}}
      </span>
      <img v-if="avatar !== ''"
      class="transition-fast"
        :src="avatar"
        @load="imgLoaded = true"
        v-bind:class="{ready: imgLoaded}">
    </div>
    <div class="cont fCol jCenter aStart">
      <h2>{{name}}</h2>
      <span v-if="showPhone">{{phone}}</span>
      <span v-if="!showPhone">@{{id}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['avatar', 'name', 'phone', 'id'],
  data() {
    return {
      imgLoaded: false,
    };
  },
  computed: {
    randomColor() {
      return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    },
    showPhone() {
      return this.phone !== '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .contactHolder {
    padding: 8px 16px;
    color: black;
    border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
    $aw: 56px;
    .av {
      width: $aw;
      min-width: $aw;
      height: $aw;
      overflow: hidden;
      position: relative;
      border-radius: $aw;
      img {
        width: $aw;
        position: absolute;
        opacity: 0;
        top: 50%;
        left: 50%;
        pointer-events: none;
        transform: translate(-50%, -50%);
      }
      img.ready {
        opacity: 1;
      }
      span {
        font-size: 16px;
        color: white;
        text-shadow: 0 1px 0 rgba($color: #000000, $alpha: 0.45);
      }
    }
    .cont {
      margin-right: 16px;
      h2 {
        margin: 0;
        padding: 0;
        color: white;
        font-size: 14px;
        font-weight: 300;
      }
      span {
        direction: ltr;
        color: white;
        font-weight: 200;
        font-size: 12px;
      }
    }
  }
  .contactHolder:hover {
    background-color: rgba($color: #000000, $alpha: 0.15);
  }
</style>
